import { render, staticRenderFns } from "./SpotRealtime.vue?vue&type=template&id=2569661a&scoped=true&"
import script from "./SpotRealtime.vue?vue&type=script&lang=js&"
export * from "./SpotRealtime.vue?vue&type=script&lang=js&"
import style0 from "./SpotRealtime.vue?vue&type=style&index=0&id=2569661a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2569661a",
  null
  
)

export default component.exports